import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  ptoIndexRequest,
  ptoIndexSuccess,
  ptoIndexFailure,
} = createActions('PTO_INDEX_SUCCESS', 'PTO_INDEX_REQUEST', 'PTO_INDEX_FAILURE');

export function requestPTOList(parentID, parentKind) {
  return (dispatch) => {
    dispatch(ptoIndexRequest());

    return request(`${parentKind}/${parentID}/ptos`)
      .then(({ json }) => dispatch(ptoIndexSuccess(json)))
      .catch(error => dispatch(ptoIndexFailure(error)));
  };
}

const {
  ptoCreateRequest,
  ptoCreateSuccess,
  ptoCreateFailure,
} = createActions('PTO_CREATE_REQUEST', 'PTO_CREATE_SUCCESS', 'PTO_CREATE_FAILURE');

export function createPTO(parentID, parentKind, pto) {
  return (dispatch) => {
    dispatch(ptoCreateRequest());

    return request(`${parentKind}/${parentID}/ptos`, { method: 'POST', body: { pto } })
      .then(({ json }) => dispatch(ptoCreateSuccess(json)))
      .catch(({ errors }) => dispatch(ptoCreateFailure({ pto, errors })));
  };
}

const {
  ptoUpdateRequest,
  ptoUpdateSuccess,
  ptoUpdateFailure,
} = createActions('PTO_UPDATE_SUCCESS', 'PTO_UPDATE_REQUEST', 'PTO_UPDATE_FAILURE');

export function updatePTO(ptoID, pto) {
  return (dispatch) => {
    dispatch(ptoUpdateRequest());

    return request(`ptos/${ptoID}`, { method: 'PATCH', body: { pto } })
      .then(({ json }) => dispatch(ptoUpdateSuccess(json)))
      .catch(({ errors }) => dispatch(ptoUpdateFailure({ pto, errors })));
  };
}

const {
  ptoDeleteRequest,
  ptoDeleteSuccess,
  ptoDeleteFailure,
} = createActions('PTO_DELETE_SUCCESS', 'PTO_DELETE_REQUEST', 'PTO_DELETE_FAILURE');

export function deletePTO(ptoID) {
  return (dispatch) => {
    dispatch(ptoDeleteRequest());

    return request(`ptos/${ptoID}`, { method: 'DELETE' })
      .then(() => dispatch(ptoDeleteSuccess({ ptoID })))
      .catch(error => dispatch(ptoDeleteFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/ptos.js